<template>
  <component :is="tag" :class="customClasses">
    <BaseIcon :type="icon" v-if="icon" />
    <slot></slot>
  </component>
</template>

<script>
import BaseIcon from './BaseIcon'
export default {
  name: 'BaseTitle',
  props: {
    tag: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: () => {}
    }
  },
  components: {
    BaseIcon
  },
  computed: {
    customClasses () {
      return [
        'title',
        `title--${this.tag}`
      ]
    }
  }
}
</script>

<style lang="scss">
  $category-colors: (
    spotlight : #C1DC00,
    modules : #C1DC00,
    stewardship : #C1DC00,
    documents : #FA9800,
    events : #CC2993,
    workgroups : #561800,
    holidays : #359A44,
    travels : #FFC000,
    remoteWorking : #3a87ad
  ) !global;

  .title{
    @include media("small-medium"){
      line-height: 1.5;
    }
    @include media("large"){
      line-height: 1.3;
    }

    font-weight: font-weights("medium");
    margin: 0;

    .tag{
      display: inline-block;
    }

    .icon::before{
      font-size: 3rem;
    }

    a{
      @include text-color(colors("font"), colors("primary"));
    }

    &--h3{
      @include media("small-medium") {
        font-size: 1.8rem;
      }
      @include media("large") {
        font-size: 2.2rem;
      }
      margin: 0;
      word-break: break-word;
      font-weight: font-weights("normal");
    }

    @each $key, $value in $category-colors{
      &.title--#{$key}{
        .icon{
          @media print {
            background-color: transparent !important;
            &:before{
              color: black !important;
            }
          }
          margin-right: 1rem;
          width: 4rem;
          height: 4rem;
          text-align: center;
          background-color: $value;
          border-top-left-radius: 50%;
          border-bottom-right-radius: 50%;

          &:before{
            color: white;
            font-size: 2rem;
          }
        }
      }
    }
  }

</style>
